<template>
  <div class="product-info">
    <section>
      <h2>
        {{ $t('product_info_title_1') }}
      </h2>
      <div class="description">
        <div class="text" style="text-align: justify">
          <i18n tag="p" path="product_info_text_1_1">
            <b>{{ $t('expedition') }}</b>
            <b>{{ $t('reception') }}</b>
            <b class="bold">SHIPPING BOARD</b>
          </i18n>
          <i18n tag="p" path="product_info_text_1_2">
            <b>{{ $t('fill_the_information') }}</b>
            <b>{{ $t('real_time_information') }}</b>
          </i18n>
        </div>
        <div class="img">
          <img src="/static/img/info_1.jpg" />
        </div>
      </div>
      <div style="text-align:center" >
        <i class="fa fa-truck lime-text fa-2x" style="margin:.5em"/>
        <i18n tag="p" path="product_info_text_1_3">
          <b class="bold">SHIPPING BOARD</b>
          <b>{{ $t('online') }}</b>
          <b>{{ $t('expeditions') }}</b>
          <b>{{ $t('receptions') }}</b>
        </i18n>
        <i18n tag="p" path="product_info_text_1_4">
          <b class="bold">SHIPPING BOARD</b>
          <b>{{ $t('export_statistics') }}</b>
          <b>{{ $t('total_control') }}</b>
        </i18n>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'product-info',
  components: { },
  props: ['tab', 'subTab']
}
</script>
<style lang="scss" scoped>
.product-info {
  box-sizing: border-box;
  section {
    max-width: 100%;
    width: 70em;
    margin: 1.5em auto;
    .description {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      .text {
        flex: 6;
        margin-right: 4%;
        min-width: 200px;
      }
      .img {
        flex: 4;
        max-width: 100%;
        margin-left: 2%;
        min-width: 250px;
      }
    }
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .card {
      cursor: default;
      transition: all .3s ease-in-out;
      background: white;
      padding: 1.5em .5em;
      border-radius: .6em;
      display: inline-block;
      box-shadow: 0 .3em .7em rgba(51, 51, 66, 0.3);
      max-width: 100%;
      width: 14em;
      margin: 2em 1em;
      .card-title {
        font-family: MuseoSans-900;
        color: #444;
        margin: .5em 0;
      }
      p{
        margin: .5em;
        font-size: 1rem!important;
      }
      &:hover {
        font-size: 1.1em;
        margin: 0 .25em;
        box-shadow: 0 .4em 1.2em rgba(51, 51, 66, 0.2);
        .fa-stack {
          animation: pulse 2s infinite;
        }
      }
    }
  }
}
@keyframes pulse {
  0% {
    transform: scale(0.97);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.97);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductInfo.vue